const ENV = 'PROD';

/* eslint-disable class-methods-use-this */
class ShopifyCartController {
  constructor(orchestrator) {
    this.orchestrator = orchestrator;
  }

  buildLineItemProperties({
    productSku,
    textProperties,
    preview,
    thumb,
    artName,
    customization = {},
  }) {
    const textEntry = {
      text: textProperties.text,
      fontFamily: textProperties.fontFamily,
      fontSize: textProperties.fontSize,
      color: textProperties.color,
    };

    if (preview) textEntry.preview = preview;
    if (thumb) textEntry.thumb = thumb;

    const properties = {
      _garrafaEstampa: 'Print My Bottle',
      _sku: productSku || '',
      _texts: JSON.stringify([textEntry]),
    };

    if (textProperties?.text) {
      properties.Texto = textProperties.text;
      properties['Cor do texto'] = textProperties.color;
    }

    if (artName) {
      properties['Modelo da estampa'] = artName;
    }

    if (customization.style) {
      properties['Estilo da personalização'] = customization.style;
    }
    if (customization.method) {
      properties['Tipo de personalização'] = customization.method;
    }
    if (customization.layout) properties.Layout = customization.layout;
    if (customization.font) properties.Fonte = customization.font;
    if (customization.laserColor) {
      properties['Cor da gravação'] = customization.laserColor;
    }

    return properties;
  }

  encodePropertiesForCartPermalink(properties) {
    const json = JSON.stringify(properties);
    const bytes = new TextEncoder().encode(json);
    let binary = '';
    bytes.forEach(byte => {
      binary += String.fromCharCode(byte);
    });

    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  buildCheckoutUrl({
    variantId,
    quantity,
    productSku,
    textProperties,
    preview,
    thumb,
    artName,
    customization,
  }) {
    if (!variantId) return null;

    const baseUrl = `${this.orchestrator.SHOPIFY_STORE_URL}/cart/${variantId}:${quantity}`;
    const properties = this.buildLineItemProperties({
      productSku,
      textProperties,
      preview,
      thumb,
      artName,
      customization,
    });
    const encodedProperties = this.encodePropertiesForCartPermalink(properties);

    return `${baseUrl}?properties=${encodedProperties}`;
  }

  /**
   * Módulos ES não enxergam const do theme-scripts; usa rotas Shopify.
   */
  getCartEndpoints() {
    const root = window.Shopify?.routes?.root || '/';
    const base = root.endsWith('/') ? root.slice(0, -1) : root;

    return {
      cart: `${base}/cart.js`,
      cartAdd: `${base}/cart/add.js`,
    };
  }

  /**
   * Fluxo nativo do tema Yuva (cart-ajax.js):
   * publish('cartUpdate', { cart, openDrawer: true }) → buildCart + abre mini cart
   */
  refreshAndOpenCartDrawer({
    cart,
    variantId,
    lineItem,
    changeType,
    oldQuantity,
    newQuantity,
  }) {
    this.orchestrator.closeCustomizerModal();

    if (typeof window.publish === 'function') {
      window.publish('cartUpdate', {
        cart,
        openDrawer: true,
        variantId,
        lineItem,
        changeType,
        oldQuantity,
        newQuantity,
      });
      return;
    }

    if (typeof window.buildCart === 'function') {
      document.body.classList.add('side_Drawer_open');
      window.buildCart(cart, true);
    }
  }

  async addCustomBottleToCart({
    variantId,
    quantity,
    productSku,
    textProperties,
    preview,
    thumb,
    artName,
    customization,
  }) {
    if (ENV !== 'PROD') return null;

    if (!variantId) {
      throw new Error('variantId não encontrado para a cor selecionada.');
    }

    const { cart: cartEndpoint, cartAdd: cartAddEndpoint } =
      this.getCartEndpoints();

    const oldCartResponse = await fetch(cartEndpoint);
    if (!oldCartResponse.ok) {
      throw new Error(oldCartResponse.status);
    }

    const oldCartData = await oldCartResponse.json();
    const properties = this.buildLineItemProperties({
      productSku,
      textProperties,
      preview,
      thumb,
      artName,
      customization,
    });

    const addResponse = await fetch(cartAddEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties,
      }),
    });

    const data = await addResponse.json();

    if (!addResponse.ok || data.status) {
      throw new Error(
        data.description || data.message || 'Erro ao adicionar ao carrinho',
      );
    }

    const newCartResponse = await fetch(cartEndpoint);
    if (!newCartResponse.ok) {
      throw new Error(newCartResponse.status);
    }

    const newCartData = await newCartResponse.json();
    const itemInOldCart = oldCartData.items.find(
      item => item.variant_id === data.variant_id,
    );

    let newQuantity = data.quantity;
    if (itemInOldCart && itemInOldCart.quantity === data.quantity) {
      newQuantity = itemInOldCart.quantity;
    }

    this.refreshAndOpenCartDrawer({
      cart: newCartData,
      variantId: data.variant_id,
      lineItem: data,
      changeType: itemInOldCart ? 'line-item:change' : 'cart:add',
      oldQuantity: itemInOldCart?.quantity,
      newQuantity,
    });

    return data;
  }
}

window.ShopifyCartController = ShopifyCartController;
